import { Box } from "@mui/material";

// Functional component representing the Services page
const Services = () => {
  return (
    <Box>
      <h1>Services</h1>
    </Box>
  );
};
export default Services;
